import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit";

import { TypedUseSelectorHook, useSelector as useReduxSelector } from "react-redux";

import addQuestionReducer from "./features/AddQuestion/addQuestion.slice";
import addschoolReducer from "./features/AddSchools/addSchools.slice";
import authReducer from "./features/Auth/auth.slice";
import catAvailabilityReducer from "./features/CATAvailability/catAvailability.slice";
import courseReducer from "./features/Course/course.slice";
import courseAddEditReducer from "./features/CourseAddEdit/courseAddEdit.slice";
import createLessonReducer from "./features/CreateLesson/createLesson.slice";
import fileVaultFolderReducer from "./features/FileVault/FileVault.slice";
import lessonsReducer from "./features/Lesson/lesson.slice";
import CommunityPoolManageSubjectsReducer from "./features/ManageCommunityPool/ManageCommunityPool.slice";
import manageLocationReducer from "./features/ManageLocations/manageLocations.slice";
import managePackageReducer from "./features/ManagePackage/managePackage.slice";
import manageSchoolRequestsReducer from "./features/ManageSchools/manageSchoolRequests.slice";
import manageSchoolsReducer from "./features/ManageSchools/manageSchools.slice";
import mergeSchoolReducer from "./features/MergeSchool/mergeSchools.slice";
import questionBankReducer from "./features/QuestionBank/questionBank.slice";
import reportsReducer from "./features/Reports/Reports.slice";
import studentsReducer from "./features/Students/students.slice";
import subjectCategoriesReducer from "./features/SubjectCategories/subjectCategories.slice";
import subjectsReducer from "./features/Subjects/Subjects.slice";
import counterReducer from "./features/counter/counter.slice";
import notificationsReducer from "./features/notifications/notifications.slice";

export const store = configureStore({
	reducer: {
		auth: authReducer,
		counter: counterReducer,
		course: courseReducer,
		students: studentsReducer,
		courseAddEdit: courseAddEditReducer,
		createLesson: createLessonReducer,
		notifications: notificationsReducer,
		questionBank: questionBankReducer,
		fileVaultFolder: fileVaultFolderReducer,
		subjects: subjectsReducer,
		addQuestion: addQuestionReducer,
		schools: manageSchoolsReducer,
		schoolRequests: manageSchoolRequestsReducer,
		addSchool: addschoolReducer,
		mergeSchool: mergeSchoolReducer,
		catAvailability: catAvailabilityReducer,
		managePackage: managePackageReducer,
		manageLocations: manageLocationReducer,
		subjectCategories: subjectCategoriesReducer,
		manageCommunityPool: CommunityPoolManageSubjectsReducer,
		lesson: lessonsReducer,
		reports: reportsReducer
	}
});

export type AppDispatch = typeof store.dispatch;

export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
